import type { SyncPreference } from '@/services/userData'

export const AUTO_SYNC_LAYOUT_WARNING =
  'Automatic sync needs attention: a tab in this spreadsheet does not use the supported transaction layout. Open the spreadsheet to review it; sync will resume after the layout is corrected.'

export function autoSyncLayoutWarning(sync?: SyncPreference): string | undefined {
  if (!sync || sync.enableAutomaticSyncing === false) return undefined
  return Object.values(sync.itemState ?? {}).some(
    (state) => state.lastErrorCode === 'sheet_layout_mismatch'
  )
    ? AUTO_SYNC_LAYOUT_WARNING
    : undefined
}
